// 国际化 - 从JSON文件加载（待实现）
let i18nData = {}
let currentLang = 'us' // 默认语言为印尼语

export function isEmpty(value) {
  return value === undefined || value === null;
}

// 根据货币代码获取货币符号
export function getCurrencySymbol(currencyCode) {
  if (!currencyCode || currencyCode.toLowerCase() === 'ldr') {
    return 'Rp'
  }
  return CURRENCY_SYMBOL_MAP[currencyCode] || currencyCode
}

const CURRENCY_SYMBOL_MAP = {
  'USD': '$',
  'IDR': 'Rp',
  'VND': '₫',
  'CNY': '¥'
}

// App唤醒链接配置
const APP_WAKE_URL = 'https://app.dmimi.ai/tiktok/auth?action=open' // 唤醒App链接

// 获取浏览器语言并设置初始语言（支持URL参数覆盖）
export function getInitialLanguage() {
  // 1. 优先从URL获取lang参数
  const urlParams = new URLSearchParams(window.location.search)
  const urlLang = urlParams.get('lang')

  console.log('[国际化] URL参数:', Object.fromEntries(urlParams))
  console.log('[国际化] URL语言参数:', urlLang)

  if (urlLang && ['en', 'zh', 'id', 'vi'].includes(urlLang.toLowerCase())) {
    console.log('[国际化] 使用URL指定的语言:', urlLang.toLowerCase())
    return urlLang.toLowerCase()
  }

  // 2. 否则使用浏览器语言
  const browserLang = navigator.language || navigator.userLanguage
  const langCode = browserLang.split('-')[0].toLowerCase()

  console.log('[国际化] 浏览器语言:', browserLang, '-> 语言代码:', langCode)

  if (['en', 'zh', 'id', 'vi'].includes(langCode)) {
    return langCode
  }

  // 3. 默认使用印尼语
  console.log('[国际化] 使用默认语言: id')
  return 'id'
}

// 从JSON文件加载国际化数据
export async function loadI18n(lang) {
  try {
    const response = await fetch(`/i18n/${lang}.json`)
    if (!response.ok) {
      throw new Error(`加载国际化文件失败: ${response.status}`)
    }
    const data = await response.json()
    console.log(`[国际化] 加载${lang}语言翻译数据:`, Object.keys(data).length, '个键值对')
    return data
  } catch (error) {
    console.warn(`加载${lang}语言国际化数据失败:`, error)
    return {}
  }
}

// 处理文本中的国际化占位符：{{i18n:key}} 或 {{i18n:key}}text{{/i18n}}
function processI18nText(text) {
  if (!text || typeof text !== 'string') return text
  // 匹配 {{i18n:key}}text{{/i18n}} 模式（带占位符）
  return text.replace(/\{\{i18n:([^}]+)\}\}(.*?)\{\{\/i18n\}\}/gs, (match, key, placeholder) => {
    return i18nData[currentLang]?.[key] || placeholder.trim()
  })
}

// 处理HTML字符串中的国际化内容（用于动态内容）
function processI18nHTML(html) {
  if (!html || typeof html !== 'string') return html
  // 简单匹配模式: {{i18n:key}}
  return html.replace(/\{\{i18n:([^}]+)\}\}/g, (match, key) => {
    return i18nData[currentLang]?.[key] || key
  })
}

// 为所有元素应用国际化翻译
export function applyI18n() {
  console.log('[国际化] 执行applyI18n，当前语言:', currentLang, '翻译键数量:', Object.keys(i18nData[currentLang] || {}).length)
  
  // 处理所有可能包含{{i18n:key}}标记的元素
  const allElements = document.querySelectorAll('.h5-share-page, .h5-share-page *')
  allElements.forEach(el => {
    // 处理包含HTML内容的元素的innerHTML
    const innerHTML = el.innerHTML
    if (innerHTML && innerHTML.includes('{{i18n:')) {
      // 使用更安全的方式：查找并替换每个{{i18n:key}}标记
      const newHTML = innerHTML.replace(/\{\{i18n:([^}]+)\}\}/g, (match, key) => {
        return i18nData[currentLang]?.[key] || key
      })
      el.innerHTML = newHTML
    }
    
    // 处理仅包含文本的元素的textContent
    const textContent = el.textContent
    if (textContent && textContent.includes('{{i18n:') && !innerHTML?.includes('{{i18n:')) {
      const newText = textContent.replace(/\{\{i18n:([^}]+)\}\}/g, (match, key) => {
        return i18nData[currentLang]?.[key] || key
      })
      el.textContent = newText
    }
  })
}

// 定义唤醒链接和应用商店链接常量
const APP_LINKS = {
  // Android Google Play 链接
  android: "https://play.google.com/store/apps/details?id=com.indonesia.cashback",
  // iOS App Store 链接
  ios: "https://apps.apple.com/id/app/cashback/id6744735674"
};

// Android intent:// 唤起所用的 App 包名
const ANDROID_APP_PACKAGE = 'com.cashback.dmimi'

// 构造 Android intent:// 链接
// 形如：intent://app.dmimi.ai/tiktok/auth?action=open#Intent;scheme=dmimi;package=com.cashback.dmimi;S.browser_fallback_url=<encoded>;end
export function buildIntentUrl(scheme, hostPath, query, fallbackUrl) {
  const intentBody = query ? `${hostPath}?${query}` : hostPath
  const parts = [
    `intent://${intentBody}#Intent`,
    `scheme=${scheme}`,
    `package=${ANDROID_APP_PACKAGE}`
  ]
  if (fallbackUrl) {
    parts.push(`S.browser_fallback_url=${encodeURIComponent(fallbackUrl)}`)
  }
  return `${parts.join(';')};end`
}

// Android 顺序唤起：优先 dmimi，失败再 https，最后兜底网页
export function wakeAppAndroid(hostPath, query, webFallback) {
  const dmimiIntent = buildIntentUrl('dmimi', hostPath, query, null)
  const httpsIntent = buildIntentUrl('https', hostPath, query, webFallback)

  const start = Date.now()
  console.log('[App] Android 尝试 dmimi intent 唤起:', dmimiIntent)
  window.location.href = dmimiIntent

  setTimeout(() => {
    // 若页面仍可见且未跳走，认为 dmimi 未拉起，重试 https intent（带网页兜底）
    if (document.visibilityState === 'visible' && Date.now() - start < 1600) {
      console.log('[App] dmimi 未唤起，重试 https intent:', httpsIntent)
      window.location.href = httpsIntent
    }
  }, 1500)
}

// 尝试唤醒App，失败则跳转到下载页
function tryWakeApp(wakeUrl, fallbackUrl) {
  const start = Date.now()
  // 通过window.open唤醒App
  window.open(wakeUrl, '_blank')

  // 简单的时间差判断：若未离开页面，则认为未安装App，跳转到下载页/应用商店
  setTimeout(() => {
    const now = Date.now()
    if (now - start < 1600) {
      window.location.href = fallbackUrl
    }
  }, 1500)
}

// 下载/打开App - 收藏按钮、底部按钮、详情图片等共用此方法
export function handleDownload() {
  // 获取用户代理信息，做兜底处理
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || ''
  console.log("handleDownload", userAgent)

  // 判断Android设备
  if (/android/i.test(userAgent)) {
    wakeAppAndroid('app.dmimi.ai/tiktok/auth', 'action=open', APP_LINKS.android)
  }
  // 判断iOS设备（排除Windows MSStream兼容问题）
  else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    tryWakeApp(APP_WAKE_URL, APP_LINKS.ios)
  }
  // 其他设备
  else {
    alert("无法跳转到应用商店，请手动下载应用。");
  }
}

/**
 * 根据设备类型跳转到对应的应用商店（仅客户端环境可用）
 * @param code - 跳转链接的专属码（可选）
export const useRedirectToAppStore = (code: string): void => {
  // 非客户端环境直接提示并返回
  if (!import.meta.client) {
    console.warn("redirectToAppStore 方法只能在客户端环境中调用。");
    return;
  }

  // 获取用户代理信息，做兜底处理
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
  console.log("useRedirectToAppStore", userAgent);

  // 定义应用商店链接常量（集中管理，便于后续修改）
  const APP_LINKS = {
    // 带码的通用跳转链接
    universal: (code: string) => `https://cashback1.onelink.me/fl9D/${code}`,
    // Android Google Play 链接
    android: "https://play.google.com/store/apps/details?id=com.indonesia.cashback",
    // iOS App Store 链接
    ios: "https://apps.apple.com/id/app/cashback/id6744735674"
  };

  // 判断Android设备
  if (/android/i.test(userAgent)) {
    code 
      ? (window.location.href = APP_LINKS.universal(code)) 
      : window.open(APP_LINKS.android, "_blank");
  }
  // 判断iOS设备（排除Windows MSStream兼容问题）
  else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    code 
      ? (window.location.href = APP_LINKS.universal(code)) 
      : window.open(APP_LINKS.ios, "_blank");
  }
  // 其他设备
  else {
    alert("无法跳转到应用商店，请手动下载应用。");
  }
};
 */

// 轮播图状态
let bannerState = {
  currentIndex: 0,
  totalImages: 0,
  startX: 0,
  currentX: 0,
  isDragging: false
}

// 从商品数据中获取轮播图图片
async function fetchBannerImages(product) {
  // 兼容product（包装后）和product.data（未包装）两种格式
  const productData = product?.data || product
  if (!productData) return []
  
  const mainImageUrls = productData.mainImageUrls || productData.mainImageUrl
  if (mainImageUrls && mainImageUrls.length > 0) {
    return Array.isArray(mainImageUrls) ? mainImageUrls : [mainImageUrls]
  }
  
  // 若无图片返回空数组
  return []
}

// 渲染轮播图
function renderBannerSlider(images) {
  const track = document.getElementById('bannerTrack')
  const counter = document.getElementById('bannerCounter')
  
  if (!track || !counter) return
  
  // 若无图片，隐藏计数器并返回
  if (!images || images.length === 0) {
    counter.style.display = 'none'
    return
  }
  
  bannerState.totalImages = images.length
  bannerState.currentIndex = 0
  
  track.innerHTML = images.map((img, index) => `
    <div class="banner-slider__item">
      <img src="${img}" alt="轮播图 ${index + 1}" />
    </div>
  `).join('')
  
  // 显示计数器并更新
  counter.style.display = ''
  updateBannerCounter()
}

// 更新轮播图计数器
function updateBannerCounter() {
  const counter = document.getElementById('bannerCounter')
  if (counter) {
    counter.textContent = `${bannerState.currentIndex + 1}/${bannerState.totalImages}`
  }
}

// 初始化轮播图并添加触摸支持
function initBannerSlider() {
  const slider = document.getElementById('bannerSlider')
  const track = document.getElementById('bannerTrack')
  
  if (!slider || !track) return
  
  // 触摸事件
  slider.addEventListener('touchstart', (e) => {
    bannerState.isDragging = true
    bannerState.startX = e.touches[0].clientX
    track.style.transition = 'none'
  })
  
  slider.addEventListener('touchmove', (e) => {
    if (!bannerState.isDragging) return
    e.preventDefault()
    bannerState.currentX = e.touches[0].clientX
    const diff = bannerState.currentX - bannerState.startX
    const offset = -(bannerState.currentIndex * 100) + (diff / slider.offsetWidth * 100)
    track.style.transform = `translateX(${offset}%)`
  })
  
  slider.addEventListener('touchend', () => {
    if (!bannerState.isDragging) return
    bannerState.isDragging = false
    track.style.transition = 'transform 0.3s ease-out'
    
    const diff = bannerState.currentX - bannerState.startX
    const threshold = slider.offsetWidth * 0.3 // 30%的滑动阈值
    
    if (Math.abs(diff) > threshold) {
      if (diff > 0 && bannerState.currentIndex > 0) {
        // 向右滑动 - 上一张
        bannerState.currentIndex--
      } else if (diff < 0 && bannerState.currentIndex < bannerState.totalImages - 1) {
        // 向左滑动 - 下一张
        bannerState.currentIndex++
      }
    }
    
    updateBannerPosition()
  })
  
  // 桌面端鼠标事件
  let mouseDown = false
  let mouseStartX = 0
  
  slider.addEventListener('mousedown', (e) => {
    mouseDown = true
    bannerState.isDragging = true
    mouseStartX = e.clientX
    bannerState.startX = e.clientX
    track.style.transition = 'none'
    e.preventDefault()
  })
  
  slider.addEventListener('mousemove', (e) => {
    if (!mouseDown || !bannerState.isDragging) return
    bannerState.currentX = e.clientX
    const diff = bannerState.currentX - bannerState.startX
    const offset = -(bannerState.currentIndex * 100) + (diff / slider.offsetWidth * 100)
    track.style.transform = `translateX(${offset}%)`
  })
  
  slider.addEventListener('mouseup', () => {
    if (!mouseDown) return
    mouseDown = false
    bannerState.isDragging = false
    track.style.transition = 'transform 0.3s ease-out'
    
    const diff = bannerState.currentX - bannerState.startX
    const threshold = slider.offsetWidth * 0.3
    
    if (Math.abs(diff) > threshold) {
      if (diff > 0 && bannerState.currentIndex > 0) {
        bannerState.currentIndex--
      } else if (diff < 0 && bannerState.currentIndex < bannerState.totalImages - 1) {
        bannerState.currentIndex++
      }
    }
    
    updateBannerPosition()
  })
  
  slider.addEventListener('mouseleave', () => {
    if (mouseDown) {
      mouseDown = false
      bannerState.isDragging = false
      track.style.transition = 'transform 0.3s ease-out'
      updateBannerPosition()
    }
  })
}

// 更新轮播图位置
function updateBannerPosition() {
  const track = document.getElementById('bannerTrack')
  if (!track) return
  
  const offset = -(bannerState.currentIndex * 100)
  track.style.transform = `translateX(${offset}%)`
  updateBannerCounter()
}

// API基础地址 - 开发环境使用代理
const API_BASE_URL = '/api'

// 从API获取商品详情
async function fetchProductData(productId) {
  const response = await fetch(`${API_BASE_URL}/creator/product/detail?productId=${productId}`)
  
  if (!response.ok) {
    throw new Error(`HTTP请求错误! 状态码: ${response.status}`)
  }
  
  return response.json()
}

// 获取相似商品列表
async function fetchSimilarProducts(productId) {
  const response = await fetch(`${API_BASE_URL}/creator/product/list?productId=${productId}`)
  
  if (!response.ok) {
    throw new Error(`HTTP请求错误! 状态码: ${response.status}`)
  }
  
  const data = await response.json()
  return data.data.list || []
}

// 获取推广视频列表
async function fetchPromotionVideos(productId) {
  const response = await fetch(`${API_BASE_URL}/creator/video/listRecommendVideos?pageNum=1&pageSize=3`)

  if (!response.ok) {
    throw new Error(`HTTP请求错误! 状态码: ${response.status}`)
  }

  const data = await response.json()
  return data.data.list || []
}


// 从接口获取数据后渲染页面
function renderProduct(product) {
  // 直接操作DOM，不需要克隆
  const container = document.querySelector('.h5-share-page')
  if (!container) return

  // 更新产品标题
  const productTitle = container.querySelector('#productTitle')
  if (!isEmpty(product.productName) && productTitle) {
    productTitle.textContent = product.productName
  }
  
  // 更新产品价格
  const productPrice = container.querySelector('#productPrice')
  if (!isEmpty(product.lowestPrice) && productPrice) {
    const currencySymbol = getCurrencySymbol(product.currency)
    productPrice.textContent = `${currencySymbol}${formatCurrency(product.lowestPrice, currencySymbol)}`
  }
  
  // 更新佣金率（我们的合作佣金率 - 粉色高亮，除以100）
  const creatorCommissionRate = container.querySelector('#creatorCommissionRate')
  if (!isEmpty(product.creatorCommissionRate) && creatorCommissionRate) {
    creatorCommissionRate.textContent = `${(product.creatorCommissionRate / 100).toFixed(2)}%`
  }
  
  // 更新市场平均佣金率（黑色字体，除以100）
  const openCollaborationCommissionRate = container.querySelector('#openCollaborationCommissionRate')
  if (!isEmpty(product.openCollaborationCommissionRate) && openCollaborationCommissionRate) {
    openCollaborationCommissionRate.textContent = `${(product.openCollaborationCommissionRate / 100).toFixed(2)}%`
  }
  
  // 更新佣金金额
  const commissionValue = container.querySelector('#commissionValue')
  if (!isEmpty(product.creatorCommission) && commissionValue) {
    const currencySymbol = getCurrencySymbol(product.currency)
    commissionValue.textContent = `${currencySymbol}${formatCurrency(product.creatorCommission, currencySymbol)}`
  }
  
  // 更新总销量
  const totalSales = container.querySelector('#totalSales')
  if (!isEmpty(product.productSales) && totalSales) {
    totalSales.textContent = formatNumber(product.productSales)
  }
  
  // 更新库存
  const stock = container.querySelector('#stock')
  if (!isEmpty(product.inventory) && stock) {
    stock.textContent = formatNumber(product.inventory)
  }
  
  // 更新样品配额
  const samples = container.querySelector('#samples')
  if (!isEmpty(product.sampleQuota) && samples) {
    samples.textContent = formatNumber(product.sampleQuota)
  }

  // 更新店铺门槛
  const thresholdSection = document.querySelector('.thresholds-section')
  if (thresholdSection) {
    const gmvLimit = product.sampleGmvLimit
    const videoLimit = product.sampleVideoLimit
    
    // 只要有一个门槛存在就展示
    if (gmvLimit != null || videoLimit != null) {
      thresholdSection.style.display = 'block'
      const threshold1 = document.getElementById('threshold1')
      const threshold2 = document.getElementById('threshold2')
      
      const currencySymbol = getCurrencySymbol(product.currency)
      
      if (threshold1) {
        threshold1.parentElement.style.display = 'flex'
        if (gmvLimit != null) {
          const template = i18nData[currentLang]?.threshold1Template || ''
          threshold1.textContent = template.replace('{gmv}', `${currencySymbol}${formatCurrency(gmvLimit, currencySymbol)}`)
        } else {
          threshold1.textContent = i18nData[currentLang]?.threshold1 || ''
        }
      }
      if (threshold2) {
        threshold2.parentElement.style.display = 'flex'
        if (videoLimit != null) {
          const template = i18nData[currentLang]?.threshold2Template || ''
          threshold2.textContent = template.replace('{views}', formatNumber(videoLimit))
        } else {
          threshold2.textContent = i18nData[currentLang]?.threshold2 || ''
        }
      }
    } else {
      // 如果没有门槛数据返回，展示默认门槛提示（来自 i18n）
      thresholdSection.style.display = 'block'
      const threshold1 = document.getElementById('threshold1')
      const threshold2 = document.getElementById('threshold2')
      if (threshold1) {
        threshold1.parentElement.style.display = 'flex'
        threshold1.textContent = i18nData[currentLang]?.threshold1 || ''
      }
      if (threshold2) {
        threshold2.parentElement.style.display = 'flex'
        threshold2.textContent = i18nData[currentLang]?.threshold2 || ''
      }
    }
  }
  
  // 存储商品数据到全局，供SKU抽屉使用
  window.currentProduct = product
}

// 格式化大数字（例如：1800 -> 1.8K）
function formatNumber(num) {
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
  }
  return num.toString()
}

// 根据货币类型格式化金额（使用千分符）
export function formatCurrency(amount, currencyType) {
  const amountNum = parseFloat(amount)
  if (isNaN(amountNum)) return amount

  // 根据货币符号判断货币类型
  // $ -> USD (逗号分隔)
  // Rp -> IDR (点分隔)
  // ₫ -> VND (点分隔)
  let isDotSeparator = false

  if (currencyType) {
    if (currencyType.includes('Rp') || currencyType.includes('IDR')) {
      isDotSeparator = true // IDR
    } else if (currencyType.includes('₫') || currencyType.includes('VND')) {
      isDotSeparator = true // VND
    }
  }

  // 获取整数部分和小数部分
  const parts = amountNum.toFixed(2).split('.')
  const integerPart = parts[0]
  const decimalPart = parts[1]

  // 格式化整数部分（千分符）
  let formattedInteger
  if (isDotSeparator) {
    // 使用点分隔 (1.000)
    formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  } else {
    // 使用逗号分隔 (1,000)
    formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  // 去除小数部分末尾的0
  let formattedDecimal = decimalPart.replace(/0+$/, '')

  // 如果小数部分全为0，则不显示小数部分
  if (formattedDecimal === '') {
    return formattedInteger
  }

  // 返回格式化后的金额
  return isDotSeparator
    ? `${formattedInteger},${formattedDecimal}`
    : `${formattedInteger}.${formattedDecimal}`
}

// 更新社交分享的meta标签
function updateMetaTags(product) {
  if (!product) return
  
  const productName = product.productName || 'Product'
  const currencySymbol = getCurrencySymbol(product.currency)
  const price = product.lowestPrice || 0
  
  // 更新或创建og:image meta标签
  let ogImage = document.querySelector('meta[property="og:image"]')
  if (!ogImage) {
    ogImage = document.createElement('meta')
    ogImage.setAttribute('property', 'og:image')
    document.head.appendChild(ogImage)
  }
  
  // 使用首张商品图片或占位图
  const imageUrl = product.mainImageUrls?.[0] || 'https://via.placeholder.com/400x400?text=Product'
  ogImage.setAttribute('content', imageUrl)
  
  // 更新或创建og:title meta标签
  let ogTitle = document.querySelector('meta[property="og:title"]')
  if (!ogTitle) {
    ogTitle = document.createElement('meta')
    ogTitle.setAttribute('property', 'og:title')
    document.head.appendChild(ogTitle)
  }
  ogTitle.setAttribute('content', productName)
  
  // 更新或创建og:description meta标签
  let ogDescription = document.querySelector('meta[property="og:description"]')
  if (!ogDescription) {
    ogDescription = document.createElement('meta')
    ogDescription.setAttribute('property', 'og:description')
    document.head.appendChild(ogDescription)
  }
  ogDescription.setAttribute('content', `${currencySymbol}${price.toFixed(2)} - ${productName}`)
  
  // 更新页面标题
  document.title = productName
}

// SKU抽屉相关函数
function openSkuDrawer() {
  const overlay = document.getElementById('skuDrawerOverlay')
  if (overlay) {
    overlay.classList.add('active')
    document.body.style.overflow = 'hidden'
  }
}

function closeSkuDrawer() {
  const overlay = document.getElementById('skuDrawerOverlay')
  if (overlay) {
    overlay.classList.remove('active')
    document.body.style.overflow = ''
  }
}

// 检查某个选项在当前已选组合下是否可用（有库存）
function isOptionAvailable(variationName, value, selectedValues, skuList) {
  for (const sku of skuList) {
    // 无效 SKU 跳过
    if (!sku.properties) continue
    const inventory = sku.inventory ?? sku.stock ?? 0
    if (inventory <= 0) continue

    // 把 properties 转成 Map 方便查找
    const propsMap = {}
    const props = Array.isArray(sku.properties) ? sku.properties : [sku.properties]
    for (const prop of props) {
      if (prop && prop.name) {
        propsMap[prop.name] = prop.value
      }
    }

    // 检查这个 SKU 是否包含当前选项
    if (propsMap[variationName] !== value) continue

    // 检查这个 SKU 是否包含所有已选中的其他分类的值
    let allMatch = true
    for (const selected of selectedValues) {
      if (selected.name === variationName) continue // 跳过当前检查的选项
      if (propsMap[selected.name] !== selected.value) {
        allMatch = false
        break
      }
    }

    if (allMatch) return true // 找到一个可用的组合
  }
  return false
}

// 从skuList中找出与给定选中项组合有关联的所有SKU
function getRelatedSkus(selectedValues, skuList) {
  // 如果没有选中任何项，返回所有有库存的SKU
  if (!selectedValues || selectedValues.length === 0) {
    return skuList.filter(sku => (sku.inventory ?? sku.stock ?? 0) > 0)
  }

  // 找出和选中项相关的SKU
  const relatedSkus = []
  for (const sku of skuList) {
    if (!sku.properties) continue
    const inventory = sku.inventory ?? sku.stock ?? 0
    if (inventory <= 0) continue

    const props = Array.isArray(sku.properties) ? sku.properties : [sku.properties]
    const propsMap = {}
    for (const prop of props) {
      if (prop && prop.name) {
        propsMap[prop.name] = prop.value
      }
    }

    // 检查这个SKU是否包含所有选中的属性
    let allMatch = true
    for (const selected of selectedValues) {
      if (propsMap[selected.name] !== selected.value) {
        allMatch = false
        break
      }
    }

    if (allMatch) {
      relatedSkus.push(sku)
    }
  }

  return relatedSkus
}

// 检查某个选项在当前选中组合下是否可能存在（有库存SKU关联）
function isOptionPotentiallyAvailable(variationName, value, selectedValues, skuList) {
  // 如果没有选中任何项，检查这个值是否存在于任何有库存的SKU中
  if (!selectedValues || selectedValues.length === 0) {
    for (const sku of skuList) {
      if (!sku.properties) continue
      const inventory = sku.inventory ?? sku.stock ?? 0
      if (inventory <= 0) continue

      const props = Array.isArray(sku.properties) ? sku.properties : [sku.properties]
      for (const prop of props) {
        if (prop && prop.name === variationName && prop.value === value) {
          return true
        }
      }
    }
    return false
  }

  // 有选中项时：
  // 1. 找出所有完全匹配 selectedValues 的 SKU（有库存的）
  // 2. 从这些匹配的 SKU 中，提取 variationName 分类的所有可用值
  // 3. 检查 value 是否在这些可用值中

  const availableValues = new Set()

  for (const sku of skuList) {
    if (!sku.properties) continue
    const inventory = sku.inventory ?? sku.stock ?? 0
    if (inventory <= 0) continue

    const props = Array.isArray(sku.properties) ? sku.properties : [sku.properties]
    const propsMap = {}
    for (const prop of props) {
      if (prop && prop.name) {
        propsMap[prop.name] = prop.value
      }
    }

    // 检查这个 SKU 是否完全匹配所有已选中的属性
    let allMatch = true
    for (const selected of selectedValues) {
      if (propsMap[selected.name] !== selected.value) {
        allMatch = false
        break
      }
    }

    if (allMatch) {
      // 完全匹配，提取 variationName 的值
      if (propsMap[variationName] !== undefined) {
        availableValues.add(propsMap[variationName])
      }
    }
  }

  // 检查 value 是否在可用值集合中
  return availableValues.has(value)
}

// 更新选项可用状态
function updateOptionsAvailability(variations, skuList, selectedValues) {
  const content = document.getElementById('skuDrawerContent')
  if (!content) return

  variations.forEach(variation => {
    const varName = variation.name
    const values = variation.values || []
    const category = content.querySelector(`.sku-category[data-category="${varName}"]`)
    if (!category) return

    // 检查这个分类是否已有选中的值
    const currentSelected = selectedValues.find(v => v.name === varName)

    values.forEach(value => {
      const option = category.querySelector(`.sku-option[data-value="${value}"]`)
      if (!option) return

      // 如果是当前分类已选中的选项，保持可用状态（不清除active）
      if (currentSelected && value === currentSelected.value) {
        option.classList.remove('unavailable')
        return
      }

      // 如果当前分类没有选中任何值，检查这个选项是否存在于任何有库存的SKU中
      if (!currentSelected) {
        const isAvailable = isOptionPotentiallyAvailable(varName, value, selectedValues, skuList)
        if (!isAvailable) {
          option.classList.add('unavailable')
        } else {
          option.classList.remove('unavailable')
        }
        return
      }

      // 不同分类的情况：检查这个选项 + 所有已选中的其他分类 是否能形成有效组合
      // 注意：selectedValues 包含当前正在检查的分类的已选中值
      // 需要排除当前分类（因为它正在被判断），只保留其他分类的选中值
      const otherSelectedValues = selectedValues.filter(v => v.name !== varName)
      const isAvailable = isOptionPotentiallyAvailable(varName, value, otherSelectedValues, skuList)
      if (!isAvailable) {
        option.classList.add('unavailable')
      } else {
        option.classList.remove('unavailable')
      }
    })
  })
}

// 获取当前选中的值列表
function getSelectedValues() {
  const selectedValues = []
  const content = document.getElementById('skuDrawerContent')
  if (!content) return selectedValues

  content.querySelectorAll('.sku-category').forEach(cat => {
    const activeOpt = cat.querySelector('.sku-option.active')
    if (activeOpt) {
      const name = cat.dataset.category || activeOpt.dataset.variationName || ''
      const value = activeOpt.dataset.value || ''
      selectedValues.push({ name, value })
    }
  })
  return selectedValues
}

// 查找匹配的SKU
function findMatchingSku(skuList, selectedValues) {
  if (!skuList || skuList.length === 0) return null

  for (const sku of skuList) {
    if (!sku.properties) continue

    const props = Array.isArray(sku.properties) ? sku.properties : [sku.properties]
    const propsMap = {}
    for (const p of props) {
      if (p && p.name) {
        propsMap[p.name] = p.value
      }
    }

    // 检查所有选中的值是否都匹配
    let allMatch = true
    for (const selected of selectedValues) {
      if (propsMap[selected.name] !== selected.value) {
        allMatch = false
        break
      }
    }

    if (allMatch) return sku
  }
  return null
}

// 获取库存文本（使用国际化）
function getStockText(inventory) {
  const stockKey = inventory > 0 ? 'stock' : 'noStock'
  const stockText = i18nData[currentLang]?.[stockKey] || (currentLang === 'zh' ? (inventory > 0 ? '库存' : '无库存') : (inventory > 0 ? 'Stock' : 'Out of Stock'))
  return inventory > 0 ? `${stockText}: ${inventory}` : stockText
}

// 获取总库存文本（使用国际化）
function getTotalStockText(totalInventory) {
  const totalStockKey = 'totalStock'
  const totalStockText = i18nData[currentLang]?.[totalStockKey] || (currentLang === 'zh' ? '总库存' : (currentLang === 'id' ? 'Total stok' : (currentLang === 'vi' ? 'Tổng kho' : 'Total Stock')))
  return `${totalStockText}: ${totalInventory}`
}

// 获取"请选择规格"文本（使用国际化）
function getSelectSpecText() {
  return i18nData[currentLang]?.selectSpec || (currentLang === 'zh' ? '请选择规格' : (currentLang === 'id' ? 'Silakan pilih spesifikasi' : (currentLang === 'vi' ? 'Vui lòng chọn thông số kỹ thuật' : 'Please select specifications')))
}

// 更新SKU显示（价格、库存、图片）
function updateSkuDisplay(skuList, currencySymbol) {
  const content = document.getElementById('skuDrawerContent')
  if (!content) return

  const selectedValues = getSelectedValues()
  const matchedSku = findMatchingSku(skuList, selectedValues)

  // 更新价格
  const priceEl = content.querySelector('.sku-item-price .price-value')
  if (priceEl) {
    if (matchedSku) {
      const symbol = getCurrencySymbol(matchedSku.currency || currencySymbol)
      const price = matchedSku.salePrice || matchedSku.listPrice || 0
      priceEl.textContent = `${symbol}${formatCurrency(price, symbol)}`
    } else {
      // 没有找到匹配的组合，显示价格区间或默认
      priceEl.textContent = '--'
    }
  }

  // 更新图片
  const imageEl = content.querySelector('.sku-item-image')
  if (imageEl) {
    if (matchedSku && matchedSku.image) {
      imageEl.src = matchedSku.image
    }
  }

  // 更新库存显示
  const skuTextEl = content.querySelector('.sku-item-sku')
  if (skuTextEl) {
    if (matchedSku) {
      const inventory = matchedSku.inventory ?? matchedSku.stock ?? 0
      skuTextEl.textContent = getStockText(inventory)
      skuTextEl.style.color = inventory > 0 ? '#333' : '#f5222d'
    } else {
      skuTextEl.textContent = getSelectSpecText()
      skuTextEl.style.color = '#999'
    }
  }
}

// 处理SKU选项点击（支持反选）
function handleSkuOptionClick(variations, skuList, currencySymbol) {
  const content = document.getElementById('skuDrawerContent')
  if (!content) return

  content.querySelectorAll('.sku-option').forEach(option => {
    option.addEventListener('click', function() {
      const category = this.closest('.sku-category')
      if (!category) return

      const varName = category.dataset.category

      // 如果点击的是已选中的选项，则反选（取消选中）
      if (this.classList.contains('active')) {
        this.classList.remove('active')
        this.classList.remove('unavailable')
      } else {
        // 移除同分类下其他选项的active类
        category.querySelectorAll('.sku-option').forEach(opt => {
          opt.classList.remove('active')
        })
        // 为当前点击的选项添加active类，并清除置灰状态
        this.classList.add('active')
        this.classList.remove('unavailable')
      }

      // 获取所有分类下选中的规格值
      const selectedValues = getSelectedValues()

      // 检查当前选中组合是否有效（有库存）
      const matchedSku = findMatchingSku(skuList, selectedValues)

      // 如果当前组合无效，需要重新选择其他分类的值
      if (!matchedSku || (matchedSku.inventory ?? matchedSku.stock ?? 0) <= 0) {
        // 对于其他分类，找到与当前选择有组合的第一个值
        for (const variation of variations) {
          const vName = variation.name
          // 跳过当前点击的分类
          if (vName === varName) continue

          const values = variation.values || []
          const catEl = content.querySelector(`.sku-category[data-category="${vName}"]`)
          if (!catEl) continue

          // 检查这个分类是否已有选中的值
          const currentSelected = selectedValues.find(v => v.name === vName)

          // 如果已经有选中的值，且与当前选择有组合，则保持
          let foundValidValue = false
          if (currentSelected) {
            // 检查当前选中的值是否与当前选择有组合
            const testValues = selectedValues.filter(v => v.name !== vName)
            const hasMatch = skuList.some(sku => {
              if (!sku.properties) return false
              const inventory = sku.inventory ?? sku.stock ?? 0
              if (inventory <= 0) return false
              const props = Array.isArray(sku.properties) ? sku.properties : [sku.properties]
              const propsMap = {}
              props.forEach(p => { if (p && p.name) propsMap[p.name] = p.value })
              // 检查是否匹配所有选中的值
              return testValues.every(v => propsMap[v.name] === v.value) &&
                     propsMap[vName] === currentSelected.value
            })
            if (hasMatch) foundValidValue = true
          }

          // 如果没有有效值，找到与当前选择有组合的第一个值
          if (!foundValidValue) {
            for (const value of values) {
              const optEl = catEl.querySelector(`.sku-option[data-value="${value}"]`)
              if (!optEl) continue

              // 检查这个值是否与当前选择有组合
              const testValues = selectedValues.filter(v => v.name !== vName)
              const hasMatch = skuList.some(sku => {
                if (!sku.properties) return false
                const inventory = sku.inventory ?? sku.stock ?? 0
                if (inventory <= 0) return false
                const props = Array.isArray(sku.properties) ? sku.properties : [sku.properties]
                const propsMap = {}
                props.forEach(p => { if (p && p.name) propsMap[p.name] = p.value })
                // 检查是否匹配所有选中的值
                return testValues.every(v => propsMap[v.name] === v.value) &&
                       propsMap[vName] === value
              })

              if (hasMatch) {
                // 清除旧的active
                catEl.querySelectorAll('.sku-option').forEach(opt => {
                  opt.classList.remove('active')
                })
                // 设置新的active
                optEl.classList.add('active')
                optEl.classList.remove('unavailable')
                foundValidValue = true
                break
              }
            }
          }
        }
      }

      // 重新获取更新后的选中值
      const newSelectedValues = getSelectedValues()

      // 更新选项可用状态（处理连锁反应）
      updateOptionsAvailability(variations, skuList, newSelectedValues)

      // 更新显示
      updateSkuDisplay(skuList, currencySymbol)
    })
  })
}

function renderSkuDrawer(product) {
  const content = document.getElementById('skuDrawerContent')
  if (!content) return

  // 如果没有商品数据，显示空抽屉
  if (!product) {
    content.innerHTML = `<div class="sku-empty" style="padding: 20px; color: #999;">${getSelectSpecText()}</div>`
    return
  }

  const currencySymbol = getCurrencySymbol(product.currency)

  // 获取首张商品图片或占位图
  const productImage = product.mainImageUrls?.[0] || product.mainImageUrl || 'https://via.placeholder.com/94x94?text=Product'

  // 从skuList获取价格区间
  const skuList = product.skuList || []
  let priceRange = ''
  if (skuList.length > 0) {
    const prices = skuList.map(sku => sku.salePrice || sku.listPrice || 0).filter(p => p > 0)
    if (prices.length > 0) {
      const minPrice = Math.min(...prices)
      const maxPrice = Math.max(...prices)
      priceRange = minPrice === maxPrice
        ? `${currencySymbol}${formatCurrency(minPrice, currencySymbol)}`
        : `${currencySymbol}${formatCurrency(minPrice, currencySymbol)} - ${currencySymbol}${formatCurrency(maxPrice, currencySymbol)}`
    } else {
      priceRange = `${currencySymbol}${formatCurrency(0, currencySymbol)}`
    }
  } else {
    priceRange = `${currencySymbol}${formatCurrency(product.lowestPrice || 0, currencySymbol)}`
  }

  // 获取规格选项
  const variations = product.variations || []

  // 找到第一个完整有库存的SKU，用于设置默认选中
  // 注意：要选中一个完整的 SKU（所有属性组合），而不是每个分类分别选
  const defaultSelectedMap = {} // name -> value
  if (skuList.length > 0) {
    for (const sku of skuList) {
      const inventory = sku.inventory ?? sku.stock ?? 0
      if (inventory > 0 && sku.properties) {
        // 从这个有库存的SKU中提取所有属性
        const props = Array.isArray(sku.properties) ? sku.properties : [sku.properties]
        let allValuesExistInVariations = true
        props.forEach(p => {
          if (p && p.name) {
            // 检查这个属性的值是否在 variations 中存在
            const variation = variations.find(v => v.name === p.name)
            if (variation && variation.values && variation.values.includes(p.value)) {
              defaultSelectedMap[p.name] = p.value
            } else {
              allValuesExistInVariations = false
            }
          }
        })
        // 如果所有属性值都在 variations 中存在，才使用这个 SKU
        if (allValuesExistInVariations && Object.keys(defaultSelectedMap).length === variations.length) {
          break // 找到第一个完整有库存的就停止
        }
        // 否则清空，重新找下一个
        for (const key in defaultSelectedMap) {
          delete defaultSelectedMap[key]
        }
      }
    }
  }

  // 渲染 variations
  const variationsHtml = variations.map((variation) => `
    <div class="sku-category" data-category="${variation.name}">
      <div class="sku-category-name">${variation.name}</div>
      <div class="sku-options">
        ${variation.values.map((value) => {
          const isActive = defaultSelectedMap[variation.name] === value ? 'active' : ''
          return `
            <button class="sku-option ${isActive}" data-value="${value}">
              ${value}
            </button>
          `
        }).join('')}
      </div>
    </div>
  `).join('')

  // 从skuList计算总库存
  let totalInventory = 0
  if (skuList.length > 0) {
    totalInventory = skuList.reduce((sum, sku) => sum + (sku.inventory ?? sku.stock ?? 0), 0)
  }

  content.innerHTML = `
    <div class="sku-item">
      <img src="${productImage}" alt="商品图片" class="sku-item-image">
      <div class="sku-item-info">
        <div class="sku-item-price">
          <span class="price-label">${i18nData[currentLang]?.price || 'Price'}</span>
          <span class="price-value">${priceRange}</span>
        </div>
        <div class="sku-item-sku">${getTotalStockText(totalInventory)}</div>
      </div>
    </div>
    ${variationsHtml}
  `

  // 更新选项可用状态和显示
  const selectedValues = getSelectedValues()
  updateOptionsAvailability(variations, skuList, selectedValues)
  updateSkuDisplay(skuList, currencySymbol)

  // 为SKU选项添加点击事件
  handleSkuOptionClick(variations, skuList, currencySymbol)

  // 为新渲染的元素重新应用国际化翻译
  applyI18n()
}

// 初始化SKU抽屉事件监听
function initSkuDrawer() {
  const openBtn = document.getElementById('openSkuDrawer')
  const closeBtn = document.getElementById('skuDrawerClose')
  const overlay = document.getElementById('skuDrawerOverlay')
  
  if (openBtn) {
    openBtn.addEventListener('click', () => {
      const product = window.currentProduct
      renderSkuDrawer(product)
      openSkuDrawer()
    })
  }
  
  if (closeBtn) {
    closeBtn.addEventListener('click', closeSkuDrawer)
  }
  
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        closeSkuDrawer()
      }
    })
  }
}

// 渲染相似商品
function renderSimilarProducts(products) {
  console.log('执行renderSimilarProducts，参数:', products)
  const container = document.getElementById('similarProductsList')
  console.log('找到相似商品容器:', !!container)
  if (!container) return
  
  console.log('相似商品数量:', products.length)
  const placeholderImage = 'https://via.placeholder.com/280x280?text=Product'
  container.innerHTML = processI18nHTML(products.map(product => {
    const title = product.campaignName || '--'
    const image = product.mainImageUrl || placeholderImage
    const currencySymbol = getCurrencySymbol(product.currency)
    const price = product.lowestPrice || 0
    const commission = product.creatorCommission || 0
    const commissionRate = (product.creatorCommissionRate || 0) / 100
    const totalSales = formatNumber(product.productSales || 0)
    
    return `
    <div class="product-card" data-product-id="${product.productId}">
      <div class="product-card-image-wrapper" style="aspect-ratio: 1; background: #f3f4f6;">
        <img src="${image}" alt="${processI18nText(title)}" class="product-card-image" onerror="this.src='${placeholderImage}'">
      </div>
      <div class="product-card-commission-title">{{i18n:commissionTitle}}</div>
      <div class="product-card-commission-rate">{{i18n:commissionRatePrefix}}: <span>${commissionRate.toFixed(2)}%</span></div>
      <div class="product-card-commission">{{i18n:commissionPrefix}}: <span>${currencySymbol}${formatCurrency(commission, currencySymbol)}</span></div>
      <div class="product-card-title">${processI18nText(title)}</div>
      <div class="product-card-info">{{i18n:pricePrefix}}: ${currencySymbol}${formatCurrency(price, currencySymbol)}</div>
      <div class="product-card-info">{{i18n:totalSalesPrefix}}: ${totalSales}</div>
      <button class="product-card-btn" data-i18n="addToShowcase">{{i18n:addToShowcase}}</button>
    </div>
  `}).join(''))
}

// 渲染推广视频
function renderPromotionVideos(videos) {
  const container = document.getElementById('videosList')
  const section = document.querySelector('.videos-section')

  if (!container || !section) return

  if (!videos || videos.length === 0) {
    // 没有数据，隐藏整个板块
    section.style.display = 'none'
    return
  }

  // 有数据，显示板块
  section.style.display = 'block'

  container.innerHTML = videos.map((video, index) => {
    const videoName = video.videoName || '--'
    const creatorName = video.creatorName || '--'
    const videoUrl = video.videoUrl || ''
    return `
    <div class="video-item" data-video-index="${index}">
      <div class="video-thumbnail">
        <span class="video-play-btn">▶</span>
      </div>
      <div class="video-name">${videoName}</div>
      <div class="video-product">${creatorName}</div>
    </div>
  `
  }).join('')

  // 绑定点击播放事件
  const videoItems = container.querySelectorAll('.video-item')
  videoItems.forEach((item, index) => {
    const video = videos[index]
    if (video && video.videoUrl) {
      item.style.cursor = 'pointer'
      item.addEventListener('click', () => {
        window.open(video.videoUrl, '_blank')
      })
    }
  })
}

// 初始化应用
async function init() {
  // 设置初始语言
  currentLang = getInitialLanguage()
  
  // 加载国际化数据
  i18nData[currentLang] = await loadI18n(currentLang)
  console.log('[国际化] 国际化数据加载完成:', Object.keys(i18nData[currentLang] || {}).length, '个键值对')
  
  // 等待DOM完全加载后应用国际化翻译
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[国际化] DOM加载完成，开始应用国际化翻译...')
      applyI18n()
    })
  } else {
    console.log('[国际化] DOM已加载完成，直接应用国际化翻译...')
    applyI18n()
  }
  
  // 从URL获取商品ID
  const urlParams = new URLSearchParams(window.location.search)
  const productId = urlParams.get('productId') || urlParams.get('id') || '1'
  
  let product = null
  
  // 获取商品数据（渲染页面必需）
  try {
    product = await fetchProductData(productId)
    renderProduct(product.data)

    // 更新分享用的meta标签
    updateMetaTags(product.data)
  } catch (error) {
    console.error('加载商品数据失败:', error)
  }
  
  // 获取轮播图图片（独立请求）
  try {
    const bannerImages = await fetchBannerImages(product)
    renderBannerSlider(bannerImages)
    initBannerSlider()
  } catch (error) {
    console.error('加载轮播图图片失败:', error)
  }
  
  // 请求相似商品列表
  try {
    const similarProducts = await fetchSimilarProducts(productId)
    renderSimilarProducts(similarProducts)
  } catch (error) {
  }
  
  // 获取推广视频列表（独立请求）
  try {
    const videos = await fetchPromotionVideos(productId)
    renderPromotionVideos(videos)
  } catch (error) {
    console.error('加载推广视频失败:', error)
  }
  
  // 动态内容渲染完成后重新应用国际化翻译
  applyI18n()
  
  // 下载按钮事件监听 - 收藏按钮和底部按钮
  const downloadBtn = document.querySelector('.download-btn')
  const starBtn = document.getElementById('bannerStar')
  
  if (downloadBtn) {
    downloadBtn.addEventListener('click', handleDownload)
  }
  
  if (starBtn) {
    starBtn.addEventListener('click', handleDownload)
  }
  
  // 商品标题展开/收起事件 - 使用事件委托
  document.addEventListener('click', (e) => {
    const productInfo = document.querySelector('.product-info')
    const productTitleWrapper = productInfo?.querySelector('.product-title-wrapper')
    // 检查点击的是不是 product-title-wrapper 或其子元素
    if (productTitleWrapper && (e.target === productTitleWrapper || productTitleWrapper.contains(e.target))) {
      productInfo.classList.toggle('expanded')
    }
  })

  // 商品详情图片点击事件 -> 下载/打开App
  const detailsContent = document.querySelector('.product-details .details-content')
  if (detailsContent) {
    detailsContent.addEventListener('click', handleDownload)
  }
  
  // 初始化SKU抽屉
  initSkuDrawer()
}

// DOM加载完成后启动应用 - 确保DOM完全加载
function startApp() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    // DOM已加载完成，立即执行
    init()
  }
}

startApp()